class GoogleSSOController {

    constructor(
        $state,
        GoogleSSOService,
    ) {
        'ngInject'

        this.$state = $state;
        this.GoogleSSOService = GoogleSSOService;
    }

    $onInit() {
        this.auth2 = null;
    }

    /***
     * Sign a user in with GoogleSSO. If successful, reload the home page. If unsuccessful,
     * present an error to the user.
     */
    doSignIn() {
        this.GoogleSSOService.signIn();
    }

    loadButton() {
        var login_uri = `${window.location.origin}/api/auth/`;
        var button_item = document.getElementById('fdt_login');
        console.log(button_item);
        var gAccounts = google.accounts;
        gAccounts.id.initialize({
            client_id: '1028546132196-srd7nv0jkc3dbqjaa1de6rleaa06484b.apps.googleusercontent.com',
            ux_mode: 'redirect',            
            login_uri: login_uri,
          });
      
         gAccounts.id.renderButton(button_item, {
            type: 'normal',
            size: 'large',
            width: 320,
         });
    }

}

export default GoogleSSOController;


// WEBPACK FOOTER //
// ./app/components/google-sso-button/google-sso-button-controller.js